/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserWithRelations } from './userWithRelations';
import { VacationPolicyWithRelations } from './vacationPolicyWithRelations';


/**
 * (tsType: VacationBalanceWithRelations, schemaOptions: { includeRelations: true })
 */
export interface VacationBalanceWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    userId: number;
    initialCutoffDays?: number;
    cutoffDate?: string;
    currentPolicyId?: string;
    totalDaysEntitled: number;
    daysUsedBeforeSystem?: number;
    daysUsed?: number;
    daysPending?: number;
    daysAvailable?: number;
    currentPeriodStart: string;
    currentPeriodEnd: string;
    lastCalculationDate?: string;
    previousPeriodDaysLost?: number;
    lastPeriodResetDate?: string;
    nextPeriodDaysReserved?: number;
    policyTypeOverride?: VacationBalanceWithRelations.PolicyTypeOverrideEnum | null;
    user?: UserWithRelations;
    currentPolicy?: VacationPolicyWithRelations;
}
export namespace VacationBalanceWithRelations {
    export type PolicyTypeOverrideEnum = 'normal' | 'sindicalizado' | 'especial';
    export const PolicyTypeOverrideEnum = {
        Normal: 'normal' as PolicyTypeOverrideEnum,
        Sindicalizado: 'sindicalizado' as PolicyTypeOverrideEnum,
        Especial: 'especial' as PolicyTypeOverrideEnum
    };
}


